import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { Grid } from '@material-ui/core';
import PropTypes from 'prop-types';
import { FormDropdown } from 'elements/Inputs/FormInput/Dropdown/Dropdown';
import { StyledLabel } from 'elements/Label/Label';
import { selectDeviceNameplateData } from './DeviceNameplate.data';
import { StyleDropdown } from '../AsFoundTestTableSection/AsFoundTestSection.styled';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1
    }
}));

const DeviceNameplateSection = (props) => {
    const { selectedTag, formData, changeHandler, formName, isFormReadOnly, userRole } = props;
    const classes = useStyles();
    return (
        <Grid container spacing={1} className={classes.root}>
            {
                selectDeviceNameplateData(selectedTag, formName, formData).rows.map(row => (
                    <Grid item container xs={12} key={row.key} style={{ padding: '0' }}>
                        {row.fields.map(field => (
                            <Grid item xs={field.xs} key={field.key}>
                                {field.isLabel
                                    ? (
                                        <StyledLabel
                                            id={field.key}
                                            label={field.label}
                                            fontWeight={field.fontWeight}
                                            textAlign={field.textAlign}
                                            labelWidth={field.labelWidth}
                                            padding={field.padding}
                                            marginLeft={field.marginLeft}
                                            fontSize={field.fontSize}
                                        >
                                            {field.label}
                                        </StyledLabel>
                                    )
                                    : (
                                        <StyleDropdown
                                            formName={formName}
                                        >
                                            <FormDropdown
                                                id={field.key}
                                                name={field.key}
                                                label={field.label}
                                                value={field.value}
                                                placeholder={field.placeholder}
                                                handleChange={changeHandler}
                                                options={field.options}
                                                isRequired={field.isRequired}
                                                width={field.width}
                                                inputTextAlign={field.inputTextAlign}
                                                labelWidth={field.labelWidth}
                                                direction={field.direction}
                                                readOnly={field.readOnly || isFormReadOnly}
                                                isDisabled={field.isDisabled}
                                                marginBottom={field.marginBottom}
                                                marginLeft={field.marginLeft}
                                                marginRight={field.marginRight}
                                                borderBottom={field.borderBottom}
                                                height={field.height}
                                                marginTop={field.marginTop}
                                                borderTop={field.borderTop}
                                                paddingPlaceholder={field.paddingPlaceholder}
                                                arrowMarginTop={field.arrowMarginTop}
                                                fontSize={field.fontSize}
                                                borderRight={field.borderRight}
                                                rootMarginRight={field.rootMarginRight}
                                                noDefaultOption={field.noDefaultOption}
                                                inputMarginRight={field.inputMarginRight}
                                                borderLeft={field.borderLeft}
                                                userRole={userRole}
                                            />
                                        </StyleDropdown>
                                    )}
                            </Grid>
                        )
                        )}
                    </Grid>
                ))
            }
        </Grid>
    );
};

const mapStateToProps = ({ Forms, Home }) => ({
    selectedTag: Forms.selectedTag,
    userRole: Home.userRole
});
const mapDispatchToProps = dispatch => ({ dispatch });

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(DeviceNameplateSection);

DeviceNameplateSection.propTypes = {
    changeHandler: PropTypes.func,
    formData: PropTypes.object,
    formName: PropTypes.string,
    isFormReadOnly: PropTypes.bool,
    selectedTag: PropTypes.object,
    userRole: PropTypes.string,
};
